import React from "react";
import Navbar from "../navbar";
import Footer from "../footer";
import { useParams } from 'react-router-dom';

function CategorySkeleton() {
  const { id } = useParams();
  
  return (
    <div className="category-skeleton">
      {/* <Navbar /> */}
      
      {/* Main Content Banner Skeleton */}
      <div className="w-full h-8 flex items-center justify-center">
        <div className="bg-gray-200 animate-pulse w-64 h-4 rounded"></div>
      </div>
      
      <div className="flex flex-col md:flex-row">
        {/* Left sidebar skeleton - reduced from 1/5 to 1/10 width */}
        <div className="w-full md:w-1/10 lg:w-1/12 p-4">
          <div className="flex flex-col gap-3">
            <div className="bg-gray-200 animate-pulse w-20 h-6 rounded mb-4"></div>
            {[1, 2, 3, 4, 5, 6, 7].map((item) => (
              <div key={item} className="bg-gray-200 animate-pulse w-full h-8 rounded mb-2"></div>
            ))}
          </div>
        </div>
        
        {/* Main content right skeleton - increased from 4/5 to 9/10 width */}
        <div className="w-full md:w-9/10 lg:w-11/12 p-4">
          {/* Banner skeleton */}
          <div className="bg-gray-200 animate-pulse w-full h-48 rounded mb-8"></div>
          
          {/* View all heading */}
          <div className="bg-gray-200 animate-pulse w-32 h-8 rounded mb-4"></div>
          
          {/* Settings skeleton */}
          <div className="flex justify-between items-center mb-6">
            <div className="flex gap-3">
              <div className="bg-gray-200 animate-pulse w-24 h-8 rounded"></div>
              <div className="bg-gray-200 animate-pulse w-32 h-8 rounded"></div>
            </div>
          </div>
          
          {/* Products grid skeleton */}
          <div className="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-6 gap-4">
            {Array(12).fill().map((_, index) => (
              <div key={index} className="flex flex-col gap-2">
                {/* Product image skeleton */}
                <div className="bg-gray-200 animate-pulse w-full aspect-[3/4] rounded"></div>
                
                {/* Product info skeleton */}
                <div className="bg-gray-200 animate-pulse w-3/4 h-4 rounded mt-2"></div>
                <div className="bg-gray-200 animate-pulse w-1/2 h-4 rounded"></div>
                
                {/* Color swatches skeleton */}
                <div className="flex gap-1 mt-1">
                  {[1, 2, 3].map((item) => (
                    <div key={item} className="bg-gray-200 animate-pulse w-4 h-4 rounded-full"></div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          
          {/* Next button skeleton */}
          <div className="flex justify-center mt-8">
            <div className="bg-gray-200 animate-pulse w-40 h-10 rounded"></div>
          </div>
        </div>
      </div>
      
      {/* <Footer /> */}
    </div>
  );
}

export default CategorySkeleton;